// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_CreateAccount from "../Ouroboros.Programs.Controllers.CreateAccount/index.js";
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var min = /* #__PURE__ */ Data_Ord.min(Data_Ord.ordInt);
var readState = function (v) {
    return v;
};
var buildCreateAccountViewProps = function (input) {
    var stepValue = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.step));
    var stepLabels = [ "Account", "Organization", "Plan", "Billing" ];
    var stepper = Data_Array.mapWithIndex(function (index) {
        return function (label) {
            return {
                label: label,
                number: Data_Int.toNumber(index) + 1.0,
                isActive: index === stepValue,
                isComplete: index < stepValue
            };
        };
    })(stepLabels);
    var stepLabel = Data_Maybe.fromMaybe("")(Data_Array.index(stepLabels)(stepValue));
    var stepIndexNumber = Data_Int.toNumber(stepValue);
    var stepNumber = stepIndexNumber + 1.0;
    var stepCountInt = Data_Array.length(stepLabels);
    var stepNext = (function () {
        var lastIndex = max(0)(stepCountInt - 1 | 0);
        return min(stepValue + 1 | 0)(lastIndex);
    })();
    var stepCount = Data_Int.toNumber(stepCountInt);
    var stepBack = max(stepValue - 1 | 0)(0);
    var controller = Ouroboros_Programs_Controllers_CreateAccount.mkCreateAccountController(input.kernel);
    return {
        mode: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.mode)),
        stepIndex: stepIndexNumber,
        stepNumber: stepNumber,
        stepCount: stepCount,
        stepLabel: stepLabel,
        stepper: stepper,
        formError: readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.form.formError)),
        email: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.email)),
        firstName: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.firstName)),
        lastName: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.lastName)),
        password: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.password)),
        confirmPassword: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.confirmPassword)),
        organizationName: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.organizationName)),
        goals: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.goals)),
        planTier: readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.form.planTier)),
        squareBilling: readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.form.squareBilling)),
        billingName: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.billingName)),
        billingCard: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.billingCard)),
        billingExp: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.billingExp)),
        billingCvc: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.billingCvc)),
        signupComplete: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.form.signupComplete)),
        onModeChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.mode))(value);
        },
        onStepNext: function (v) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.step))(stepNext);
        },
        onStepBack: function (v) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.step))(stepBack);
        },
        onStepReset: function (v) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.step))(0);
        },
        onFormErrorChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.form.formError))(value);
        },
        onEmailChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.email))(value);
        },
        onFirstNameChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.firstName))(value);
        },
        onLastNameChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.lastName))(value);
        },
        onPasswordChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.password))(value);
        },
        onConfirmPasswordChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.confirmPassword))(value);
        },
        onOrganizationNameChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.organizationName))(value);
        },
        onGoalsChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.goals))(value);
        },
        onPlanTierChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.form.planTier))(value);
        },
        onSquareBillingChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.form.squareBilling))(value);
        },
        onBillingNameChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.billingName))(value);
        },
        onBillingCardChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.billingCard))(value);
        },
        onBillingExpChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.billingExp))(value);
        },
        onBillingCvcChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.form.billingCvc))(value);
        },
        onOrganizationSignup: function (maybeRequest) {
            return Ouroboros_Programs_Controllers_CreateAccount.runCreateAccountAction(controller.onOrganizationSignup(maybeRequest));
        },
        onProceedToApp: function (payload) {
            return Ouroboros_Programs_Controllers_CreateAccount.runCreateAccountAction(controller.onProceedToApp(payload));
        },
        onNavigateToLogin: function (v) {
            return Ouroboros_Programs_Controllers_CreateAccount.runCreateAccountAction(controller.onNavigateToLogin);
        },
        onResetToChoice: function (v) {
            return Ouroboros_Programs_Controllers_CreateAccount.runCreateAccountAction(controller.onResetToChoice);
        },
        onHandleNext: function (v) {
            return Ouroboros_Programs_Controllers_CreateAccount.runCreateAccountAction(controller.onHandleNext(stepValue)(stepNext));
        },
        onHandleBack: function (v) {
            return Ouroboros_Programs_Controllers_CreateAccount.runCreateAccountAction(controller.onHandleBack(stepBack));
        },
        onHandleSubmit: function (v) {
            return Ouroboros_Programs_Controllers_CreateAccount.runCreateAccountAction(controller.onHandleSubmit(stepValue));
        }
    };
};
export {
    buildCreateAccountViewProps
};
//# sourceMappingURL=index.js.map
